import type { MarketingBannerRow, MarketingBannersTranslations } from "./types";

import { ChartLineIcon, DownloadIcon, EditIcon, EyeIcon } from "../Icons";
import { BannerButtonText, BannerCopyButtonText } from "./BannerButtonText";

type BannerBottomSheetMenuProps = {
  banner: MarketingBannerRow;
  translations: MarketingBannersTranslations;
  onView: () => void;
  onCopy?: () => void;
  onRename: () => void;
  onDownload: () => void;
  /** Performance Report deep-link. */
  performanceHref?: string;
  onViewPerformance?: () => void;
  onNavigateToPerformance?: (href: string) => void;
};

export const BannerBottomSheetMenu = ({
  banner,
  translations,
  onView,
  onCopy,
  onRename,
  onDownload,
  performanceHref,
  onViewPerformance,
  onNavigateToPerformance,
}: BannerBottomSheetMenuProps) => {
  const { copied } = translations.actions;
  const { copyLabel } = translations.actions.getCopyLabels(banner.type);

  const isBannerImage = banner.type === "image_banner";

  return (
    <div className="flex w-full touch-none flex-col items-start justify-stretch px-4 py-3">
      <BannerButtonText
        icon={<EyeIcon width={18} height={18} />}
        text={translations.actions.mobileView}
        onClick={onView}
      />
      <BannerCopyButtonText
        copyLabel={copyLabel}
        copiedLabel={copied}
        text={banner.creative_code}
        onClick={onCopy}
        iconSize={18}
      />
      {performanceHref && translations.actions.viewPerformance && (
        <BannerButtonText
          icon={<ChartLineIcon width={18} height={18} />}
          text={translations.actions.viewPerformance}
          onClick={() => {
            onViewPerformance?.();
            if (onNavigateToPerformance) {
              onNavigateToPerformance(performanceHref);
              return;
            }
            window.open(performanceHref, "_self");
          }}
        />
      )}
      <BannerButtonText
        icon={<EditIcon width={18} height={18} />}
        text={translations.actions.rename}
        onClick={onRename}
      />
      {isBannerImage && (
        <BannerButtonText
          icon={
            <DownloadIcon
              width={18}
              height={18}
              className="[&_path]:stroke-text-primary"
            />
          }
          text={translations.actions.downloadPng}
          onClick={onDownload}
        />
      )}
    </div>
  );
};
